import { FlashMessage, FlashMessageProps } from '@cropink/ui-components';
import { createElement } from 'react';
import { Id, ToastOptions, cssTransition, toast } from 'react-toastify';

const bounce = cssTransition({
  enter: 'animate__animated animate__fadeIn',
  exit: 'animate__animated animate__fadeOut',
});

const configuration: ToastOptions = {
  autoClose: 2000,
  hideProgressBar: true,
  draggable: false,
  transition: bounce,
  closeButton: false,
  position: 'bottom-center',
};

const sendDefaultOptions: Omit<FlashMessageProps, 'text'> = {
  variant: 'neutral',
};

export class NotificationService {
  static send = (
    text: string,
    options?: Omit<FlashMessageProps, 'text'>,
    config?: ConfigToastOptions,
  ): Id =>
    toast(
      createElement(FlashMessage, {
        text,
        ...{ ...sendDefaultOptions, ...options },
      }),
      { ...configuration, ...config },
    );

  static remove = (id: Id): void => toast.dismiss(id);
}

type ConfigToastOptions = Pick<
  ToastOptions,
  'autoClose' | 'position' | 'closeButton' | 'closeOnClick'
>;
